export const LOCAL_STORAGE_KEYS = {
	GRADING_SAVED_SEARCHES_EXPLANATION_DISMISSED: 'gradingSavedSearchesExplanationDismissed',
} as const;
